// src/components/feature-configurator/components/TypingDots.tsx

import { Box } from "@mui/material";
import {
  ACCENT,
  COBALT,
  blinkDots,
} from "../feature-configurator/utils/constants";

export default function TypingDots() {
  return (
    <Box
      sx={{
        display: "inline-flex",
        gap: 0.6,
        alignItems: "center",
        ...blinkDots,
        "& > span": {
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: `linear-gradient(180deg, ${ACCENT}, ${COBALT})`,
          animation: "blink 1200ms infinite ease-in-out",
        },
        "& > span:nth-of-type(2)": { animationDelay: "150ms" },
        "& > span:nth-of-type(3)": { animationDelay: "300ms" },
      }}
    >
      <span />
      <span />
      <span />
    </Box>
  );
}
